
      const env = import.meta.env.VITE_BFB_ENV || import.meta.env.REACT_APP_BFB_ENV || 'dev';
      window.node_env = import.meta.env.MODE;
      window.env = env;
      window.dev = env === 'dev';
      window.staging = env === 'staging';
      window.prod = env === 'production';
    